import React from 'react';
import ReactDOM from 'react-dom';
//import 'milligram/dist/milligram.min.css'
import App from './app';

// Run App
ReactDOM.render(<App />, document.getElementById('root'));


